
const AppLogoBackground = () => {
    return (
        <svg width="100px" height="100px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>PP</title>
            <defs>
                <linearGradient x1="14.5829429%" y1="14.574848%" x2="85.3911513%" y2="85.3830563%" id="linearGradient-1">
                    <stop stop-color="#96EAF1" offset="0%"></stop>
                    <stop stop-color="#98E3F0" offset="12.32%"></stop>
                    <stop stop-color="#9FD1EC" offset="29.66%"></stop>
                    <stop stop-color="#A9B3E5" offset="49.99%"></stop>
                    <stop stop-color="#B889DD" offset="72.58%"></stop>
                    <stop stop-color="#CA54D2" offset="96.77%"></stop>
                    <stop stop-color="#CD4CD0" offset="100%"></stop>
                    <stop stop-color="#CF50D1" offset="100%"></stop>
                    <stop stop-color="#D55DD3" offset="100%"></stop>
                    <stop stop-color="#DF73D6" offset="100%"></stop>
                    <stop stop-color="#EE91DB" offset="100%"></stop>
                    <stop stop-color="#FFB6E1" offset="100%"></stop>
                </linearGradient>
            </defs>
            <g id="Path-Pilot-App" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="Group-90" transform="translate(-897, -403)" fill="url(#linearGradient-1)">
                    <g id="Group-9" transform="translate(634, 145)">
                        <g id="Group-12" transform="translate(263, 258)">
                            <circle id="Oval" cx="50" cy="50" r="50"></circle>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}

export default AppLogoBackground;
